import * as React from 'react'

import { cn } from '@/lib/utils'

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex min-h-24 w-full min-w-0 rounded-md border border-slate-200 bg-transparent px-3 py-2 text-base transition-[color,box-shadow] outline-none placeholder:text-slate-500 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:border-slate-800 dark:bg-slate-200/30',
        'focus-visible:border-slate-950 focus-visible:ring-[1px] focus-visible:ring-slate-950/50',
        'aria-invalid:border-red aria-invalid:ring-red/20',
        className,
      )}
      {...props}
    />
  )
}

export { Textarea }
